import { createContext } from 'react';
export const WindowDimensionsContext = /*#__PURE__*/createContext({
  width: window.innerWidth,
  height: window.innerHeight,
  deviceWidth: window.screen.width,
  deviceHeight: window.screen.height
});